import {z} from 'zod';
import {isPossiblePhoneNumber} from 'react-phone-number-input';

export const phoneNumberSchema = z.string().nullable().optional().refine(
	v => !v || isPossiblePhoneNumber(v),
	{message: 'Please enter a valid phone number'},
);